export default __webpack_public_path__ + "static/media/CRMDesktop.6d4c2833.png";